/* tslint:disable:max-line-length no-bitwise */
import {Injectable, OnDestroy} from '@angular/core';
import {Classifications} from '@docma-mm-core/classification/classification';
import {Contact} from '@docma-mm-core/contact/contact';
import {Craft} from '@docma-mm-core/craft/craft';
import {FieldMinimal} from '@docma-mm-core/field/field';
import {Layout} from '@docma-mm-core/layout/layout';
import {LoadState} from '@docma-mm-core/model/load-state/load-state';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {MmModel} from '@docma-mm-core/model/mm.model';
import {Order} from '@docma-mm-core/order/order';
import {Project as MmProject} from '@docma-mm-core/project/project';
import {Status} from '@docma-mm-core/status/status';
import {flattenStructure, Structure} from '@docma-mm-core/structure/structure';
import {UserDefineds} from '@docma-mm-core/user-defined/user-defined';
import {NotificationService} from '@mydocma/component-library/src/lib/notification';
import {ConnectivityService} from '@mydocma/core';
import {Project as MydocmaProject} from '@mydocma/project';
import {BehaviorSubject, defer, firstValueFrom, map, Observable, of, switchMap, forkJoin} from 'rxjs';
import {filter, take, tap} from 'rxjs/operators';
import {MmProjectOfflineService} from './mm-project-offline.service';
import {DocumentType} from '@docma-mm-core/document-type/document-type';
import {Company} from '@docma-mm-core/company/company';
import {PlanData} from '@docma-mm-core/plan/plan';
import {ProjectSetting} from '@docma-mm-core/project-settings/project-setting';
import {ProjectUserPermissions} from '@docma-mm-core/permission/project-user-permissions';
import {Attribute} from '@docma-mm-core/attribute/attribute';
import {AttributeGroup} from '@docma-mm-core/attribute-group/attribute-group';
import {AttributeGroupFile} from '@docma-mm-core/attribute-group/attribute-group-file';
import {ProjectSettingEnum} from '@docma-mm-core/project/configuration/project-setting.enum';
import {Delay} from '@docma-mm-core/delay/delay';
import {Pool} from '@docma-mm-core/pool/pool';
import { PlatformModeStateService } from '../mm-offline/services/platform-mode-state.service';
import {Phase} from '@docma-mm-core/phase/phase';
import {Integration} from '@docma-mm-core/integration/integration';
import {IntegrationFile} from '@docma-mm-core/integration/integration-file';
import {ConfigPermissionEnum} from '@docma-mm-core/permission/config-permission.enum';
import {DataAccessPermissionEnum} from '@docma-mm-core/permission/data-access-permission.enum';
import {FieldPropertyEnum} from '@docma-mm-core/field/field-property.enum';
import {ConfigLoadEnum} from '@docma-mm-core/permission/config-load.enum';
import {Logger} from '@mydocma/common/src/lib/logger';

@Injectable()
export class MmProjectLoaderService implements OnDestroy {


  projectSubject = new BehaviorSubject<MmModel<MmProject>>((new MmModel<MmProject>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private filedsSubject = new BehaviorSubject<MmModel<FieldMinimal[]>>((new MmModel<FieldMinimal[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private layoutsSubject = new BehaviorSubject<MmModel<Layout[]>>((new MmModel<Layout[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private poolsSubject = new BehaviorSubject<MmModel<Pool[]>>((new MmModel<Pool[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private structuresSubject = new BehaviorSubject<MmModel<Structure[]>>((new MmModel<Structure[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private ordersSubject = new BehaviorSubject<MmModel<Order[]>>((new MmModel<Order[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private craftsSubject = new BehaviorSubject<MmModel<Craft[]>>((new MmModel<Craft[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private contactsSubject = new BehaviorSubject<MmModel<Contact[]>>((new MmModel<Contact[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  userDefinedsSubject = new BehaviorSubject<MmModel<UserDefineds>>(new MmModel<UserDefineds>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  }));
  private classificationsSubject = new BehaviorSubject<MmModel<Classifications>>((new MmModel<Classifications>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private statusesSubject = new BehaviorSubject<MmModel<Status[]>>((new MmModel<Status[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private documentTypesSubject = new BehaviorSubject<MmModel<DocumentType[]>>((new MmModel<DocumentType[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private companiesSubject = new BehaviorSubject<MmModel<Company[]>>((new MmModel<Company[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private plansSubject = new BehaviorSubject<MmModel<PlanData[]>>((new MmModel<PlanData[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private projectSettingsSubject = new BehaviorSubject<MmModel<ProjectSetting[]>>((new MmModel<ProjectSetting[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private projectUserPermssionsSubject = new BehaviorSubject<MmModel<ProjectUserPermissions>>((new MmModel<ProjectUserPermissions>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private attributesSubject = new BehaviorSubject<MmModel<Attribute[]>>((new MmModel<Attribute[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private attributeGroupsSubject = new BehaviorSubject<MmModel<AttributeGroup[]>>((new MmModel<AttributeGroup[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private attributeGroupsFilesSubject = new BehaviorSubject<MmModel<AttributeGroupFile[]>>((new MmModel<AttributeGroupFile[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private delaysSubject = new BehaviorSubject<MmModel<Delay[]>>((new MmModel<Delay[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private phasesSubject = new BehaviorSubject<MmModel<Phase[]>>((new MmModel<Phase[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private integrationsSubject = new BehaviorSubject<MmModel<Integration[]>>((new MmModel<Integration[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));
  private integrationsFilesSubject = new BehaviorSubject<MmModel<IntegrationFile[]>>((new MmModel<IntegrationFile[]>({
    loadState: new LoadState({
      data: null,
      status: LoadStatusEnum.Loading
    })
  })));


  public project = this.projectSubject.asObservable();
  public fields = this.filedsSubject.asObservable();
  public layouts = this.layoutsSubject.asObservable();
  public pools = this.poolsSubject.asObservable();
  public structures = this.structuresSubject.asObservable();
  public orders = this.ordersSubject.asObservable();
  public crafts = this.craftsSubject.asObservable();
  public contacts = this.contactsSubject.asObservable();
  public userDefineds = this.userDefinedsSubject.asObservable();
  public classifications = this.classificationsSubject.asObservable();
  public statuses = this.statusesSubject.asObservable();
  public documentTypes = this.documentTypesSubject.asObservable();
  public companies = this.companiesSubject.asObservable();
  public plans = this.plansSubject.asObservable();
  public projectSettings = this.projectSettingsSubject.asObservable();
  public projectUserPermissions = this.projectUserPermssionsSubject.asObservable();
  public attributes = this.attributesSubject.asObservable();
  public attributeGroups = this.attributeGroupsSubject.asObservable();
  public attributeGroupsFiles = this.attributeGroupsFilesSubject.asObservable();
  public delays = this.delaysSubject.asObservable();
  public phases = this.phasesSubject.asObservable();
  public integrations = this.integrationsSubject.asObservable();
  public integrationsFiles = this.integrationsFilesSubject.asObservable();

  constructor(private readonly connectivityService: ConnectivityService,
              private readonly offlineService: MmProjectOfflineService,
              private readonly notificationService: NotificationService,
              private readonly platformModeStateService: PlatformModeStateService,
              private readonly logger: Logger) {
  }

  ngOnDestroy(): void {
  }

  public getCurrentStructures(): Structure[] {
    return this.structuresSubject.value?.loadState?.data ?? [];
  }

  public async persistCurrentStructures(): Promise<void> {
    const project = this.projectSubject.value?.data;
    const structures = this.getCurrentStructures();
    if (!project?.MyDocmaUid || !structures?.length) return;
    try {
      await this.offlineService.saveStructures(project, structures);
    } catch (e) {
      this.logger.error(e, '', 'MmProjectLoaderService.persistCurrentStructures');
    }
  }

  public notifyStructuresChanged(): void {
    const current = this.structuresSubject.value;
    if (!current?.loadState?.data) return;
    this.structuresSubject.next(new MmModel<Structure[]>({
      loadState: new LoadState({
        data: [...current.loadState.data],
        status: current.loadState.status,
      }),
    }));
  }

  public refreshStructures(): Observable<Structure[]> {
    const project = this.projectSubject.value?.data;
    if (!project) return of([]);
    return this.offlineService.getStructures(project, true);
  }

  private onStartLoading() {
    this.projectSubject.next(new MmModel<MmProject>({
      loadState: new LoadState({
        data: new MmProject(),
        status: LoadStatusEnum.Loading
      })
    }));
    this.layoutsSubject.next(new MmModel<Layout[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.poolsSubject.next(new MmModel<Pool[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.filedsSubject.next(new MmModel<FieldMinimal[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.structuresSubject.next(new MmModel<Structure[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.ordersSubject.next(new MmModel<Order[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.craftsSubject.next(new MmModel<Craft[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.contactsSubject.next(new MmModel<Contact[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.userDefinedsSubject.next(new MmModel<UserDefineds>({
      loadState: new LoadState({
        data: new UserDefineds(),
        status: LoadStatusEnum.Loading
      })
    }));
    this.classificationsSubject.next(new MmModel<Classifications>({
      loadState: new LoadState({
        data: new Classifications(),
        status: LoadStatusEnum.Loading
      })
    }));
    this.statusesSubject.next(new MmModel<Status[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.documentTypesSubject.next(new MmModel<DocumentType[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.companiesSubject.next(new MmModel<Company[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.plansSubject.next(new MmModel<PlanData[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.documentTypesSubject.next(new MmModel<DocumentType[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.companiesSubject.next(new MmModel<Company[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.projectSettingsSubject.next(new MmModel<ProjectSetting[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.projectUserPermssionsSubject.next(new MmModel<ProjectUserPermissions>({
      loadState: new LoadState({
        data: new ProjectUserPermissions(),
        status: LoadStatusEnum.Loading
      })
    }));
    this.attributesSubject.next(new MmModel<Attribute[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.attributeGroupsSubject.next(new MmModel<AttributeGroup[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.attributeGroupsFilesSubject.next(new MmModel<AttributeGroupFile[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.delaysSubject.next(new MmModel<Delay[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.phasesSubject.next(new MmModel<Phase[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.integrationsSubject.next(new MmModel<Integration[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.integrationsFilesSubject.next(new MmModel<IntegrationFile[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
  }

  private reset() {
    this.projectSubject.next(new MmModel<MmProject>({
      loadState: new LoadState({
        data: null,
        status: LoadStatusEnum.Loading
      })
    }));
    this.layoutsSubject.next(new MmModel<Layout[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.poolsSubject.next(new MmModel<Pool[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.filedsSubject.next(new MmModel<FieldMinimal[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.structuresSubject.next(new MmModel<Structure[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.ordersSubject.next(new MmModel<Order[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.craftsSubject.next(new MmModel<Craft[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.contactsSubject.next(new MmModel<Contact[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.userDefinedsSubject.next(new MmModel<UserDefineds>({
      loadState: new LoadState({
        data: new UserDefineds(),
        status: LoadStatusEnum.Loading
      })
    }));
    this.classificationsSubject.next(new MmModel<Classifications>({
      loadState: new LoadState({
        data: new Classifications(),
        status: LoadStatusEnum.Loading
      })
    }));
    this.statusesSubject.next(new MmModel<Status[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.documentTypesSubject.next(new MmModel<DocumentType[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.companiesSubject.next(new MmModel<Company[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.plansSubject.next(new MmModel<PlanData[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.documentTypesSubject.next(new MmModel<DocumentType[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.projectSettingsSubject.next(new MmModel<ProjectSetting[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.projectUserPermssionsSubject.next(new MmModel<ProjectUserPermissions>({
      loadState: new LoadState({
        data: new ProjectUserPermissions(),
        status: LoadStatusEnum.Loading
      })
    }));
    this.attributesSubject.next(new MmModel<Attribute[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.attributeGroupsSubject.next(new MmModel<AttributeGroup[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.attributeGroupsFilesSubject.next(new MmModel<AttributeGroupFile[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.delaysSubject.next(new MmModel<Delay[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.phasesSubject.next(new MmModel<Phase[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.integrationsSubject.next(new MmModel<Integration[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
    this.integrationsFilesSubject.next(new MmModel<IntegrationFile[]>({
      loadState: new LoadState({
        data: [],
        status: LoadStatusEnum.Loading
      })
    }));
  }

  public loadProject(mydocmaProject: MydocmaProject): Observable<MmProject> {

    return defer(async () => {

      this.reset();
      if (!mydocmaProject) {
        return null;
      }

      // console.debug('MmProjectLoaderService: Loading project ... Project: ' + mydocmaProject.id);
      this.onStartLoading();

      const isNewDb = await firstValueFrom(this.offlineService.isNewDb(mydocmaProject.id));

      let project: MmProject;
      try {
        if (!isNewDb) {
          project = await firstValueFrom(this.offlineService.getProject(mydocmaProject.id, false));
        }
        let settings: ProjectSetting[];
        if (!this.connectivityService.isOfflineVal && this.platformModeStateService.isOnline) {
          project = await firstValueFrom(this.offlineService.getProject(mydocmaProject.id, true));
          settings = await firstValueFrom(this.loadProjectSettings(project, true));
        } else if (project) {
          settings = await firstValueFrom(this.loadProjectSettings(project, false));
        }

        if (project) {
          this.checkBpConnection(project, settings);
          this.projectSubject.value.loadState = new LoadState({data: project, status: LoadStatusEnum.Loaded});
        } else {
          this.projectSubject.value.loadState = new LoadState({status: LoadStatusEnum.Error});
          this.projectSubject.value.loadState.error = `Project "${mydocmaProject.name} - ${mydocmaProject.desc}" not found in mm`;
          this.logger.error(this.projectSubject.value.loadState.error, '', 'MmProjectLoaderService');
          this.notificationService.error(this.projectSubject.value.loadState.error);
        }

      } catch (err) {
        this.logger.error(err, '', 'MmProjectLoaderService');
        this.projectSubject.value.loadState = new LoadState({status: LoadStatusEnum.Error});
        this.projectSubject.value.loadState.error = `Could not load mm project "${mydocmaProject.name} - ${mydocmaProject.desc}"`;
        this.notificationService.error(this.projectSubject.value.loadState.error);
      }

      if (this.projectSubject.value.loadState.status !== LoadStatusEnum.Loaded) {
        this.projectSubject.next(this.projectSubject.value);
        return project;
      }

      const fieldDict2: {[config: string]: FieldPropertyEnum[]} = Object.fromEntries([
        [ConfigLoadEnum.Classification, [FieldPropertyEnum.Class1, FieldPropertyEnum.Class2, FieldPropertyEnum.Class3, FieldPropertyEnum.Class4]],
        [ConfigLoadEnum.Company, [FieldPropertyEnum.Company, FieldPropertyEnum.ContactCO_Company, FieldPropertyEnum.ContactCT_Company, FieldPropertyEnum.ContactSC_Company, FieldPropertyEnum.CostsCompany]],
        [ConfigLoadEnum.Craft, [FieldPropertyEnum.Craft]],
        [ConfigLoadEnum.Order, [FieldPropertyEnum.Order, FieldPropertyEnum.CostsOrder]],
        [ConfigLoadEnum.Contact, [FieldPropertyEnum.ContactCO, FieldPropertyEnum.ContactCT, FieldPropertyEnum.ContactSC]],
        [ConfigLoadEnum.UserDefined, [FieldPropertyEnum.UserDefined1, FieldPropertyEnum.UserDefined2]],
        [ConfigLoadEnum.Attribute, [FieldPropertyEnum.Attribute, FieldPropertyEnum.AttributeGroup_Image]],
      ]);


      // Load persisted values from db
      if (!isNewDb) {
        await firstValueFrom(
          forkJoin([this.loadProjectUserPermssions(project, false).pipe(map(m => Object.fromEntries((m.Configs || []).map(c => [c.Config, c.Permission])) )),
            this.loadFields(project, false).pipe(map(m => Object.fromEntries(m.map(f => [f.Prop, f.Permission]) ) ))])
            .pipe(
            switchMap(([ConfigPermissions, FieldPermissions]) => {
              // Build an array of observables conditionally
              const loaders = [
                this.loadStructures(project, false).pipe(
                  switchMap(() =>
                    this.structures.pipe(
                      filter(m => m?.loadState?.status === LoadStatusEnum.Loaded),
                      take(1),
                      map(m => flattenStructure(m.data)),
                      switchMap(structures => this.loadPlans(project, structures, false))
                    )
                  )
                ),
                // permissions.hasOwnProperty(ConfigPermissionEnum.ProjectCompany) && (permissions[ConfigPermissionEnum.ProjectCompany] & DataAccessPermissionEnum.Read) === DataAccessPermissionEnum.Read
                this.loadLayouts(project, false),
                this.loadPools(project, false),
                ...(fieldDict2[ConfigLoadEnum.Order].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadOrders(project, false)] : [this.clearOrders(project)]),
                ...(fieldDict2[ConfigLoadEnum.Craft].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadCrafts(project, false)] : [this.clearCrafts(project)]),
                ...(fieldDict2[ConfigLoadEnum.Contact].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadContacts(project, false)] : [this.clearContacts(project)]),
                this.loadCompanies(project, false),
                ...(fieldDict2[ConfigLoadEnum.UserDefined].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadUserDefineds(project, false)] : [this.clearUserDefineds(project)]),
                ...(fieldDict2[ConfigLoadEnum.Classification].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadClassifications(project, false)] : [this.clearClassifications(project)]),
                this.loadStatuses(project, false),
                this.loadDocumentTypes(project, false),
                this.loadProjectSettings(project, false),
                this.loadAttributes(project, false),
                this.loadAttributeGroups(project, false),
                this.loadDelays(project, false),
                this.loadPhases(project, false),
                this.loadIntegrations(project, false),
              ];
              return forkJoin(loaders);
            })
          )
        );
      }

      // console.debug('MmProjectLoaderService: Project loaded. Project: ' + mydocmaProject.id);
      this.projectSubject.next(this.projectSubject.value);

      // setTimeout(() => {
      // Start loading values from server if online
      if (!this.connectivityService.isOfflineVal && this.platformModeStateService.isOnline) {
        const loader = firstValueFrom(
          forkJoin([this.loadProjectUserPermssions(project, true).pipe(map(m => Object.fromEntries(m.Configs.map(c => [c.Config, c.Permission])) )),
            this.loadFields(project, true).pipe(map(m => Object.fromEntries(m.map(f => [f.Prop, f.Permission]) ) ))])
            .pipe(
              switchMap(([ConfigPermissions, FieldPermissions]) => {
                // Build an array of observables conditionally
                const loaders = [
                  this.loadStructures(project, true)
                  .pipe(switchMap(loadedStructures => this.structures.pipe(filter(m => m?.loadState?.status === LoadStatusEnum.Loaded),
                    take(1),
                    map(m => flattenStructure(m.data)))
                    .pipe(switchMap(structures => this.loadPlans(project, structures, true)
                    ))
                  )),
                  // permissions.hasOwnProperty(ConfigPermissionEnum.ProjectCompany) && (permissions[ConfigPermissionEnum.ProjectCompany] & DataAccessPermissionEnum.Read) === DataAccessPermissionEnum.Read
                  this.loadLayouts(project, true),
                  this.loadPools(project, true),
                  ...(fieldDict2[ConfigLoadEnum.Order].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadOrders(project, true)] : [this.clearOrders(project)]),
                  ...(fieldDict2[ConfigLoadEnum.Craft].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadCrafts(project, true)] : [this.clearCrafts(project)]),
                  ...(fieldDict2[ConfigLoadEnum.Contact].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadContacts(project, true)] : [this.clearContacts(project)]),
                  this.loadCompanies(project, true),
                  ...(fieldDict2[ConfigLoadEnum.UserDefined].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadUserDefineds(project, true)] : [this.clearUserDefineds(project)]),
                  ...(fieldDict2[ConfigLoadEnum.Classification].some(x => FieldPermissions.hasOwnProperty(x) && FieldPermissions[x] !== undefined && FieldPermissions[x] >= 0) ? [this.loadClassifications(project, true)] : [this.clearClassifications(project)]),
                  this.loadStatuses(project, true),
                  this.loadDocumentTypes(project, true),
                  this.loadProjectSettings(project, true),
                  this.loadAttributes(project, true),
                  this.loadAttributeGroups(project, true),
                  this.loadDelays(project, true),
                  this.loadPhases(project, true),
                  this.loadIntegrations(project, true),
                ];
                return forkJoin(loaders);
              })
            )
        );
        if (isNewDb) {
          await loader;
        }
      }
      // }, 2000);


      return project;
    });

  }


  private checkBpConnection(project: MmProject, settings: ProjectSetting[]) {
    const planSource = settings.find(s => s.Key === ProjectSettingEnum.PlanSource);
    const textPinFieldSettings = settings.find(value => value.Key === 'SelectedPlanField' && value?.Setting);
    project.BPConnected = ((planSource && planSource.Setting === 'BP') ?? false);
    project.textPinEnabled = settings.some(value => value.Key === 'IsPlanPinsEnabled' && value.Setting === 'True');
    project.textPinFieldId = textPinFieldSettings?.Setting;
  }

  private loadClassifications(project: MmProject, forceRefresh: boolean): Observable<Classifications> {
    return this.offlineService.getClassifications(project, forceRefresh)
      .pipe(
        tap(uds => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.classificationsSubject.next(
              new MmModel<Classifications>({loadState: new LoadState({data: uds, status: LoadStatusEnum.Loaded})})
            );
          }
        })
      );
  }

  private loadUserDefineds(project: MmProject, forceRefresh: boolean): Observable<UserDefineds> {
    return this.offlineService.getUserDefineds(project, forceRefresh)
      .pipe(
        tap(uds => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.userDefinedsSubject.next(new MmModel<UserDefineds>({
              loadState: new LoadState({
                data: uds,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadContacts(project: MmProject, forceRefresh: boolean): Observable<Craft[]> {
    return this.offlineService.getContacts(project, forceRefresh)
      .pipe(
        tap(cs => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.contactsSubject.next(new MmModel<Contact[]>({
              loadState: new LoadState({
                data: cs,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  public loadCrafts(project: MmProject, forceRefresh: boolean): Observable<Craft[]> {
    return this.offlineService.getCrafts(project, forceRefresh)
      .pipe(
        tap(cs => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.craftsSubject.next(new MmModel<Craft[]>({
              loadState: new LoadState({
                data: cs,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadStatuses(project: MmProject, forceRefresh: boolean): Observable<Status[]> {
    return this.offlineService.getStatuses(project, forceRefresh)
      .pipe(
        tap(ss => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.statusesSubject.next(new MmModel<Status[]>({
              loadState: new LoadState({
                data: ss,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadDocumentTypes(project: MmProject, forceRefresh: boolean): Observable<DocumentType[]> {
    return this.offlineService.getDocumentTypes(project, forceRefresh)
      .pipe(
        tap(ss => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.documentTypesSubject.next(new MmModel<DocumentType[]>({
              loadState: new LoadState({
                data: ss,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  public loadCompanies(project: MmProject, forceRefresh: boolean): Observable<Company[]> {
    return this.offlineService.getCompanies(project, forceRefresh)
      .pipe(
        tap(ss => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.companiesSubject.next(new MmModel<Company[]>({
              loadState: new LoadState({
                data: ss,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  public async removeCompanies(project: MmProject, removed: Company[]) {
    const removedById: { [Uid: string]: Company } = Object.fromEntries(removed.map(m => [m.Id, m]));

    this.offlineService.getCompanies(project, false).pipe(
      switchMap(companies =>  this.offlineService.getContacts(project, false).pipe(
        switchMap(contacts =>  this.offlineService.getOrders(project, false).pipe(
          map(orders => ({companies, contacts, orders}) )
          ))
        )
      )
    ).subscribe(async params => {
      if (this.projectSubject.value.data.Id === project.Id) {
        await this.offlineService.removeOrders(project, params.orders.filter(x => removedById.hasOwnProperty(x.Company.Id)));
        await this.offlineService.removeContacts(project, params.contacts.filter(x => removedById.hasOwnProperty(x.Company.Id)));
        await this.offlineService.removeCompanies(project, params.companies.filter(x => removedById.hasOwnProperty(x.Id)));

        this.ordersSubject.next(new MmModel<Order[]>({
          loadState: new LoadState({
            data: params.orders.filter(x => !removedById.hasOwnProperty(x.Company.Id)),
            status: LoadStatusEnum.Loaded
          })
        }));

        this.contactsSubject.next(new MmModel<Contact[]>({
          loadState: new LoadState({
            data: params.contacts.filter(x => !removedById.hasOwnProperty(x.Company.Id)),
            status: LoadStatusEnum.Loaded
          })
        }));

        this.companiesSubject.next(new MmModel<Company[]>({
          loadState: new LoadState({
            data: params.companies.filter(x => !removedById.hasOwnProperty(x.Id)),
            status: LoadStatusEnum.Loaded
          })
        }));
      }
    });
  }

  public async removeContacts(project: MmProject, removed: Contact[]) {
    const removedById: { [Uid: string]: Contact } = Object.fromEntries(removed.map(m => [m.Id, m]));

    this.offlineService.getContacts(project, false)
      .subscribe(async contacts => {
        if (this.projectSubject.value.data.Id === project.Id) {
          await this.offlineService.removeContacts(project, contacts.filter(x => removedById.hasOwnProperty(x.Id)));

          this.contactsSubject.next(new MmModel<Contact[]>({
            loadState: new LoadState({
              data: contacts.filter(x => !removedById.hasOwnProperty(x.Id)),
              status: LoadStatusEnum.Loaded
            })
          }));
        }
      });
  }

  public async removeOrders(project: MmProject, removed: Order[]) {
    const removedById: { [Uid: string]: Order } = Object.fromEntries(removed.map(m => [m.Id, m]));

    this.offlineService.getOrders(project, false)
      .subscribe(async orders => {
        if (this.projectSubject.value.data.Id === project.Id) {
          await this.offlineService.removeOrders(project, orders.filter(x => removedById.hasOwnProperty(x.Id)));

          this.ordersSubject.next(new MmModel<Order[]>({
            loadState: new LoadState({
              data: orders.filter(x => !removedById.hasOwnProperty(x.Id)),
              status: LoadStatusEnum.Loaded
            })
          }));
        }
      });
  }


  public loadOrders(project: MmProject, forceRefresh: boolean): Observable<Order[]> {
    return this.offlineService.getOrders(project, forceRefresh)
      .pipe(
        tap(os => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.ordersSubject.next(new MmModel<Order[]>({
              loadState: new LoadState({
                data: os,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }


  private loadLayouts(project: MmProject, forceRefresh: boolean): Observable<Layout[]> {
    return this.offlineService.getLayouts(project, forceRefresh)
      .pipe(
        tap(ls => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.layoutsSubject.next(new MmModel<Layout[]>({
              loadState: new LoadState({
                data: ls,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  loadLayoutsByAddedOrUpdated(project: MmProject, layout: Layout, forceRefresh: boolean): Observable<Layout[]> {
    return this.offlineService.getLayoutsByAddedOrUpdated(project, layout, forceRefresh)
      .pipe(
        tap(ls => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.layoutsSubject.next(new MmModel<Layout[]>({
              loadState: new LoadState({
                data: ls,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  loadLayoutsByDeleted(project: MmProject, layoutId: number, forceRefresh: boolean): Observable<Layout[]> {
    return this.offlineService.getLayoutsByDeleted(project, layoutId, forceRefresh)
      .pipe(
        tap(ls => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.layoutsSubject.next(new MmModel<Layout[]>({
              loadState: new LoadState({
                data: ls,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadPools(project: MmProject, forceRefresh: boolean): Observable<Pool[]> {
    return this.offlineService.getPools(project, forceRefresh)
      .pipe(
        tap(ls => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.poolsSubject.next(new MmModel<Pool[]>({
              loadState: new LoadState({
                data: ls,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  loadPoolsByAddedOrUpdated(project: MmProject, pool: Pool | Pool[], forceRefresh: boolean): Observable<Pool[]> {
    return this.offlineService.getPoolsByAddedOrUpdated(project, pool, forceRefresh)
      .pipe(
        tap(ls => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.poolsSubject.next(new MmModel<Pool[]>({
              loadState: new LoadState({
                data: ls,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  loadPoolsByDeleted(project: MmProject, poolId: number, forceRefresh: boolean): Observable<Pool[]> {
    return this.offlineService.getPoolsByDeleted(project, poolId, forceRefresh)
      .pipe(
        tap(ls => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.poolsSubject.next(new MmModel<Pool[]>({
              loadState: new LoadState({
                data: ls,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  public loadFields(project: MmProject, forceRefresh: boolean): Observable<FieldMinimal[]> {
    return this.offlineService.getFields(project, forceRefresh)
      .pipe(
        tap(fs => {
          if (this.projectSubject.value.data.Id === project.Id && (fs?.length ?? 0) > 0) {
            this.filedsSubject.next(new MmModel<FieldMinimal[]>({
              loadState: new LoadState({
                data: fs,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadStructures(project: MmProject, forceRefresh: boolean): Observable<Structure[]> {
    return this.offlineService.getStructures(project, forceRefresh)
      .pipe(
        tap(ss => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.structuresSubject.next(new MmModel<Structure[]>({
              loadState: new LoadState({
                data: ss,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }


  private loadPlans(project: MmProject, structures: Structure[], forceRefresh: boolean): Observable<PlanData[]> {
    return this.offlineService.getPlans(project, structures, forceRefresh)
      .pipe(
        tap(ps => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.plansSubject.next(new MmModel<PlanData[]>({
              loadState: new LoadState({
                data: ps,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadProjectSettings(project: MmProject, forceRefresh: boolean): Observable<ProjectSetting[]> {
    return this.offlineService.getProjectSettings(project, forceRefresh)
      .pipe(
        tap(ps => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.checkBpConnection(project, ps);
            this.projectSettingsSubject.next(new MmModel<ProjectSetting[]>({
              loadState: new LoadState({
                data: ps,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadProjectUserPermssions(project: MmProject, forceRefresh: boolean) {
    return this.offlineService.getPermissions(project, forceRefresh)
      .pipe(
        tap(pup => {
          if (this.projectSubject.value.data.Id == project.Id) {
            this.projectUserPermssionsSubject.next(new MmModel({
              loadState: new LoadState({
                data: pup,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadAttributes(project: MmProject, forceRefresh: boolean): Observable<Attribute[]> {
    return this.offlineService.getAttributes(project, forceRefresh)
      .pipe(
        tap(data => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.attributesSubject.next(new MmModel<Status[]>({
              loadState: new LoadState({
                data,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadAttributeGroups(project: MmProject, forceRefresh: boolean): Observable<{
    attributeGroup: AttributeGroup[],
    attributeGroupFiles: AttributeGroupFile[]
  }> {
    return this.offlineService.getAttributeGroups(project, forceRefresh)
      .pipe(
        tap(data => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.attributeGroupsSubject.next(new MmModel<AttributeGroup[]>({
              loadState: new LoadState({
                data: data.attributeGroup,
                status: LoadStatusEnum.Loaded
              })
            }));
            this.attributeGroupsFilesSubject.next(new MmModel<AttributeGroupFile[]>({
              loadState: new LoadState({
                data: data.attributeGroupFiles,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadDelays(project: MmProject, forceRefresh: boolean): Observable<Delay[]> {
    return this.offlineService.getDelays(project, forceRefresh)
      .pipe(
        tap(data => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.delaysSubject.next(new MmModel<Delay[]>({
              loadState: new LoadState({
                data,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadPhases(project: MmProject, forceRefresh: boolean): Observable<Phase[]> {
    return this.offlineService.getPhases(project, forceRefresh)
      .pipe(
        tap(ss => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.phasesSubject.next(new MmModel<Phase[]>({
              loadState: new LoadState({
                data: ss,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private loadIntegrations(project: MmProject, forceRefresh: boolean): Observable<{integrations: Integration[], integrationsFiles: IntegrationFile[]}> {
    return this.offlineService.getIntegrations(project, forceRefresh)
      .pipe(
        tap(data => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.integrationsSubject.next(new MmModel<Integration[]>({
              loadState: new LoadState({
                data: data.integrations,
                status: LoadStatusEnum.Loaded
              })
            }));
            this.integrationsFilesSubject.next(new MmModel<IntegrationFile[]>({
              loadState: new LoadState({
                data: data.integrationsFiles,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  public updateCompaniesSubject(data: Company[]) {
    this.companiesSubject.next(new MmModel<Company[]>({
      loadState: new LoadState({
        data,
        status: LoadStatusEnum.Loaded
      })
    }));
  }

  public updateContactsSubject(data: Contact[]) {
    this.contactsSubject.next(new MmModel<Contact[]>({
      loadState: new LoadState({
        data,
        status: LoadStatusEnum.Loaded
      })
    }));
  }

  public updateOrdersSubject(data: Order[]) {
    this.ordersSubject.next(new MmModel<Order[]>({
      loadState: new LoadState({
        data,
        status: LoadStatusEnum.Loaded
      })
    }));
  }

  public updateCraftsSubject(data: Craft[]) {
    this.craftsSubject.next(new MmModel<Craft[]>({
      loadState: new LoadState({
        data,
        status: LoadStatusEnum.Loaded
      })
    }));
  }

  private clearCompanies(project: MmProject) {
    return this.offlineService.clearCompanies(project)
      .pipe(
        tap(os => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.companiesSubject.next(new MmModel<Company[]>({
              loadState: new LoadState({
                data: os,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private clearCrafts(project: MmProject) {
    return this.offlineService.clearCrafts(project)
      .pipe(
        tap(os => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.craftsSubject.next(new MmModel<Craft[]>({
              loadState: new LoadState({
                data: os,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private clearOrders(project: MmProject) {
    return this.offlineService.clearOrders(project)
      .pipe(
        tap(os => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.ordersSubject.next(new MmModel<Order[]>({
              loadState: new LoadState({
                data: os,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private clearContacts(project: MmProject) {
    return this.offlineService.clearContacts(project)
      .pipe(
        tap(os => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.contactsSubject.next(new MmModel<Contact[]>({
              loadState: new LoadState({
                data: os,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private clearUserDefineds(project: MmProject) {
    return this.offlineService.clearUserDefineds(project)
      .pipe(
        tap(os => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.userDefinedsSubject.next(new MmModel<UserDefineds>({
              loadState: new LoadState({
                data: os,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

  private clearClassifications(project: MmProject) {
    return this.offlineService.clearClassifications(project)
      .pipe(
        tap(os => {
          if (this.projectSubject.value.data.Id === project.Id) {
            this.classificationsSubject.next(new MmModel<Classifications>({
              loadState: new LoadState({
                data: os,
                status: LoadStatusEnum.Loaded
              })
            }));
          }
        })
      );
  }

}
